import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '@/components/Header';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { BookOpen } from 'lucide-react';

const GettingStarted = () => {
  const navigate = useNavigate();
  
  const articles = [
    {
      title: "Understanding Karta Pobytu Requirements",
      description: "Essential requirements and eligibility criteria",
      path: "/knowledge-base/karta-pobytu-requirements"
    },
    {
      title: "Document Checklist for First-Time Applicants",
      description: "Complete list of required documents",
      path: "/knowledge-base/document-checklist"
    },
    {
      title: "Step-by-Step Application Process",
      description: "Detailed guide to the application process",
      path: "/knowledge-base/application-process"
    },
    {
      title: "Common Mistakes to Avoid",
      description: "Learn from others' experiences and avoid common pitfalls",
      path: "/knowledge-base/common-mistakes"
    }
  ];

  const handleCardClick = (path: string) => {
    navigate(path);
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center mb-4">
            <div className="p-3 bg-primary/10 rounded-lg">
              <BookOpen className="h-8 w-8 text-primary" />
            </div>
          </div>
          <h1 className="text-4xl font-bold text-foreground mb-4">
            Getting Started Guide
          </h1>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Essential information for new residence permit applicants
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {articles.map((article, index) => (
            <Card 
              key={index}
              className="hover:shadow-lg transition-all duration-300 hover:scale-105 cursor-pointer"
              onClick={() => handleCardClick(article.path)}
            >
              <CardHeader>
                <CardTitle className="text-xl text-foreground">{article.title}</CardTitle>
                <CardDescription className="text-muted-foreground">
                  {article.description}
                </CardDescription>
              </CardHeader>
            </Card>
          ))}
        </div>

        <div className="mt-12 text-center">
          <button
            onClick={() => navigate('/knowledge-base')}
            className="text-primary hover:text-primary/80 transition-colors"
          >
            ← Back to Knowledge Base
          </button>
        </div>
      </div>
    </div>
  );
};

export default GettingStarted; 